import styled from 'styled-components';
import theme from '../../../../theme';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    margin: 10px 0;

    > span {
        margin: 10px 0 20px 0;
        font-size: 13px;
        font-weight: 400;
        color: ${theme.textDark};
    }
    
    ul {
        list-style-type: none;
        width: 100%;

        li + li {
            margin-top: 10px;
        }


        li {
            background-color: #EDEEF2;
            padding: 10px;
            border-radius: 8px;
            /* cursor: pointer; */

            strong {
                font-size: 16px;
                font-weight: 700;
                color: ${theme.textDark};
            }

            > div {
                display: flex;
                align-items: start;
                justify-content: space-between;
            }
        }
    }
`;

const LeftSide = styled.div`
    display: flex;
    flex-direction: column;

    small {
        font-size: 13px;
        font-weight: 400;
        color: ${theme.textDark};
    }
`;

const RightSide = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;

    svg {
        margin-right: 20px;
    }
`;

const RightSideResume = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 14px;
        height: 14px;
    }

    span {
        font-size: 16px;
        font-weight: 900;
        color: ${theme.textDark};
        margin-left: 3px;
    }
`;

export { Container, LeftSide, RightSide, RightSideResume };